import styled from 'styled-components';

export const TabPaneStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  flex: 1 0 0;

  span {
    color: #343a40;
    font-size: 1.01563rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
